<section
  class="DocumentSection"
  *ngIf="section.answer && !section.emphasis"
  [class.NewLine]="section.newLine"
  [class.DocumentSection--flash]="isFlash(documentType)"
  [class.DocumentSection--overview]="documentType === 'OVERVIEW_DOC'"
  [ngClass]="section.alignment"
  [class.Hide]="section.name === 'Infringements'">
  <div class="Anchor-section" id="{{section.uuid}}"></div>
  <ng-container *ngIf="section.sectionDtoType === 'TABLEVIEW'">
    <!-- DESKTOP TABLES -->
    <div *ngIf="!isMobile" class="Tables">
      <div class="TableHeader" id="TableHeader" [innerHtml]="section.answer" (scroll)="syncScrollTableElements('TableHeader')"></div>
      <div class="TableBody-container" id="TableBody" (scroll)="syncScrollTableElements('TableBody')">
        <div class="TableBody" [innerHtml]="section.answer"></div>
      </div>
    </div>
    <!-- MOBILE TABLES -->
    <div *ngIf="isMobile" class="ShowTableOnMobile">
      <div class="MiniTable" *ngIf="section.tableViewHeaders">
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{tabName}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="MobileMiniTable-content">
              <p>Benchmarking on:</p>
              <ul class="List-firstLevel">
                <li *ngFor="let column of section.tableViewHeaders.columns">
                  <p>{{column.name}}</p>
                </li>
              </ul>
              <footer>
                <a [routerLink]=" '../' + uniqueNumber + '/table/fullView/' + section.uuid" class="Button">
                  <span>Display full table</span>
                </a>
              </footer>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="section.sectionDtoType != 'TABLEVIEW'">
    <div [ngClass]="section.containerStyle">
      <ng-container *ngIf="displaySectionName(documentType)">
        <div *ngIf="showSectionName" class="ArticleSeparator">{{section.name}}</div>
      </ng-container>
      <ng-container *ngIf="documentType === 'BIG5_SECTION'">
        <div class="ArticleSeparator">
          <span *ngFor="let pillar of section.pillarDtos">{{('uishared.pillars.'+pillar.code) | transloco}}</span> - {{('uishared.CountryNames.'+section.countryCode) | transloco}}
        </div>
      </ng-container>
      <ng-container *ngFor="let pillar of section.pillarDtos">
        <div *ngIf="pillar.visible" class="ArticleSeparator">{{('uishared.pillars.'+pillar.code) | transloco}}</div>
      </ng-container>
      <h2 *ngIf="section.title" class="DocumentSection-title">{{section.title}}</h2>
      <!-- TOPICS -->
      <div class="Topics-container-desktop" *ngIf="featureFlagService.isTopicsContainerEnabled()">
        <icullen-topics [topics]="section.topics"></icullen-topics>
      </div>
      <div class="Answer" [class.Answer--infogram]="section.answer.includes('infogram')" #answerContainer *ngIf="section.answer" [innerHtml]="section.answer | linkifyImage" runScript></div>
    </div>
  </ng-container>
</section>